const translations = {
    noFarmsFound: 'No farms found.',
    search: 'Search',
    selectAClientToSeeFarms: 'Please select a client to see farms.'
};

export default translations;
